// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2OVx6","productName":"Table_productName__3SDv7"};